import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e337d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-[#16161d] text-left" }, "Candidatos para o convite de troca", -1))
const _hoisted_2 = { class: "flex flex-col gap-4 text-left" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_4 = { class: "flex items-center justify-between mb-3.5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold text-primary30" }, "Convidados diretos", -1))
const _hoisted_6 = { class: "text-sm text-[#52526f]" }
const _hoisted_7 = { class: "flex items-start gap-3" }
const _hoisted_8 = ["cx", "cy", "stroke"]
const _hoisted_9 = ["cx", "cy", "stroke", "stroke-dashoffset"]
const _hoisted_10 = { class: "flex-1 flex flex-col gap-0.5 min-w-0 overflow-hidden" }
const _hoisted_11 = { class: "text-sm font-semibold text-[#222]" }
const _hoisted_12 = { class: "text-xs text-[#52526f]" }
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-[#52526f]"
}
const _hoisted_14 = {
  key: 1,
  class: "text-xs font-medium text-[#a15c07]",
  "data-testid": "candidate-expiration"
}
const _hoisted_15 = {
  key: 2,
  class: "text-xs text-[#999] italic"
}
const _hoisted_16 = { class: "shrink-0" }
const _hoisted_17 = {
  key: 0,
  class: "h-3.5"
}
const _hoisted_18 = {
  key: 1,
  class: "h-px bg-[#e0e0e0]"
}
const _hoisted_19 = {
  key: 2,
  class: "h-3.5"
}
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_21 = { class: "flex items-center justify-between mb-3.5" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold text-primary30" }, "Candidatos da vitrine", -1))
const _hoisted_23 = { class: "text-sm text-[#52526f]" }
const _hoisted_24 = { class: "flex items-start gap-3" }
const _hoisted_25 = ["cx", "cy", "stroke"]
const _hoisted_26 = ["cx", "cy", "stroke", "stroke-dashoffset"]
const _hoisted_27 = { class: "flex-1 flex flex-col gap-0.5 min-w-0 overflow-hidden" }
const _hoisted_28 = { class: "text-sm font-semibold text-[#222]" }
const _hoisted_29 = { class: "text-xs text-[#52526f]" }
const _hoisted_30 = {
  key: 0,
  class: "text-xs text-[#52526f]"
}
const _hoisted_31 = {
  key: 1,
  class: "text-xs font-medium text-[#a15c07]",
  "data-testid": "candidate-expiration"
}
const _hoisted_32 = {
  key: 2,
  class: "text-xs text-[#999] italic"
}
const _hoisted_33 = { class: "shrink-0" }
const _hoisted_34 = {
  key: 0,
  class: "h-3.5"
}
const _hoisted_35 = {
  key: 1,
  class: "h-px bg-[#e0e0e0]"
}
const _hoisted_36 = {
  key: 2,
  class: "h-3.5"
}

import { computed } from 'vue'
import { differenceInDays, differenceInHours, format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { InviteResponseV2 } from '@/Network/Types/Responses/HandoverInviteResponses'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'
import { getDoctorInitials } from '@/utils/string'
import { InviteStatus, InviteOrigin } from '@/Network/Types/Requests/HandoverInviteRequests'
import { classifyNpsScore, NEUTRAL_RING_COLOR } from '@/utils/nps'

const AVATAR_SIZE = 40
const STROKE_WIDTH = 4

export default /*#__PURE__*/_defineComponent({
  __name: 'CandidatesModal',
  props: {
    modelValue: { type: Boolean },
    invites: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

const RADIUS = AVATAR_SIZE / 2 + STROKE_WIDTH / 2
const SVG_SIZE = RADIUS * 2 + STROKE_WIDTH
const CIRCUMFERENCE = 2 * Math.PI * RADIUS
const INNER_STYLE = {
  width: AVATAR_SIZE + 'px',
  height: AVATAR_SIZE + 'px',
  top: STROKE_WIDTH + 'px',
  left: STROKE_WIDTH + 'px'
}

function getClampedScore(score?: number | null): number {
  if (score == null) return 0
  return Math.min(100, Math.max(0, score))
}

function getArcOffset(score?: number | null): number {
  return CIRCUMFERENCE * (1 - getClampedScore(score) / 100)
}

function getArcColor(score?: number | null): string {
  if (score == null) return NEUTRAL_RING_COLOR
  return classifyNpsScore(score).color
}





const directInvites = computed(() => props.invites.filter((i) => i.origin === InviteOrigin.DIRECT))

const showcaseInvites = computed(() =>
  props.invites.filter((i) => i.origin === InviteOrigin.SHOWCASE)
)

const acceptedDirectQueue = computed(() =>
  directInvites.value
    .filter((i) => i.status === InviteStatus.ACCEPTED)
    .sort((a, b) => {
      if (!a.acceptedAt || !b.acceptedAt) return 0
      return new Date(a.acceptedAt).getTime() - new Date(b.acceptedAt).getTime()
    })
)

function getQueuePosition(invite: InviteResponseV2): number {
  return acceptedDirectQueue.value.findIndex((i) => i.id === invite.id) + 1
}

const AVATAR_COLORS = [
  '#4778c7',
  '#804db2',
  '#995933',
  '#2e7d32',
  '#c62828',
  '#00838f',
  '#ad1457',
  '#4527a0',
  '#ef6c00',
  '#1565c0'
]

function getAvatarColor(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

function formatAcceptedAt(dateStr: string): string {
  try {
    const date = parseISO(dateStr)
    return format(date, "EEE dd/MM 'às' HH'h'mm", { locale: ptBR })
  } catch {
    return dateStr
  }
}

/**
 * Prazo restante do convite, só para quem ainda pode responder. Um convite já
 * respondido ou já vencido tem o próprio status contando a história — repetir o
 * prazo ali só competiria com ele.
 */
function getExpirationLabel(invite: InviteResponseV2): string | null {
  if (invite.status !== InviteStatus.PENDING || !invite.expiresAt) return null

  try {
    const expiresAt = parseISO(invite.expiresAt)
    const hours = differenceInHours(expiresAt, new Date())
    if (hours < 0) return null
    if (hours < 24) return `Expira em ${hours} ${hours === 1 ? 'hora' : 'horas'}`

    const days = differenceInDays(expiresAt, new Date())
    return `Expira em ${days} ${days === 1 ? 'dia' : 'dias'}`
  } catch {
    return null
  }
}

function getStatusLabel(invite: InviteResponseV2): string {
  if (invite.status === InviteStatus.ACCEPTED) {
    const pos = getQueuePosition(invite)
    return pos > 0 ? `${pos}º na fila` : 'Aceito'
  }
  if (invite.status === InviteStatus.PENDING) return 'Aguardando'
  if (invite.status === InviteStatus.DECLINED) return 'Recusou'
  if (invite.status === InviteStatus.EXPIRED) return 'Expirado'
  if (invite.status === InviteStatus.CANCELLED) return 'Cancelado'
  return invite.status
}

function getStatusBadgeClasses(invite: InviteResponseV2): string {
  if (invite.status === InviteStatus.ACCEPTED) {
    return 'bg-primary5 text-[#235e6c]'
  }
  return 'bg-[#e2e2e9] text-[#999]'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modelValue,
    "max-width": "max-w-[678px]",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (directInvites.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(directInvites.value.length) + " " + _toDisplayString(directInvites.value.length === 1 ? 'convidado' : 'convidados'), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directInvites.value, (invite, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: invite.id
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "relative shrink-0",
                      style: _normalizeStyle({ width: SVG_SIZE + 'px', height: SVG_SIZE + 'px' })
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        width: SVG_SIZE,
                        height: SVG_SIZE,
                        class: "absolute top-0 left-0 -rotate-90",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("circle", {
                          cx: SVG_SIZE / 2,
                          cy: SVG_SIZE / 2,
                          r: RADIUS,
                          stroke: _unref(NEUTRAL_RING_COLOR),
                          "stroke-width": STROKE_WIDTH,
                          fill: "none"
                        }, null, 8, _hoisted_8),
                        (getClampedScore(invite.doctor.npsScore) > 0)
                          ? (_openBlock(), _createElementBlock("circle", {
                              key: 0,
                              cx: SVG_SIZE / 2,
                              cy: SVG_SIZE / 2,
                              r: RADIUS,
                              stroke: getArcColor(invite.doctor.npsScore),
                              "stroke-width": STROKE_WIDTH,
                              fill: "none",
                              "stroke-dasharray": CIRCUMFERENCE,
                              "stroke-dashoffset": getArcOffset(invite.doctor.npsScore),
                              "stroke-linecap": "round"
                            }, null, 8, _hoisted_9))
                          : _createCommentVNode("", true)
                      ])),
                      _createElementVNode("div", {
                        class: "absolute rounded-full flex items-center justify-center text-sm font-semibold text-white",
                        style: _normalizeStyle({ ...INNER_STYLE, backgroundColor: getAvatarColor(invite.doctor.name) })
                      }, _toDisplayString(_unref(getDoctorInitials)(invite.doctor.name)), 5)
                    ], 4),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getFirstAndSecondName)(invite.doctor.name)), 1),
                      _createElementVNode("span", _hoisted_12, "CRM " + _toDisplayString(invite.doctor.crm), 1),
                      (invite.acceptedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Aceitou em " + _toDisplayString(formatAcceptedAt(invite.acceptedAt)), 1))
                        : _createCommentVNode("", true),
                      (getExpirationLabel(invite))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(getExpirationLabel(invite)), 1))
                        : _createCommentVNode("", true),
                      (invite.declineReason)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Motivo: " + _toDisplayString(invite.declineReason), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-block px-2 py-[3px] rounded-[10px] text-[11px] font-medium whitespace-nowrap", getStatusBadgeClasses(invite)])
                      }, _toDisplayString(getStatusLabel(invite)), 3)
                    ])
                  ]),
                  (index < directInvites.value.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                    : _createCommentVNode("", true),
                  (index < directInvites.value.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                    : _createCommentVNode("", true),
                  (index < directInvites.value.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (showcaseInvites.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(showcaseInvites.value.length) + " " + _toDisplayString(showcaseInvites.value.length === 1 ? 'candidato' : 'candidatos'), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showcaseInvites.value, (invite, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: invite.id
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", {
                      class: "relative shrink-0",
                      style: _normalizeStyle({ width: SVG_SIZE + 'px', height: SVG_SIZE + 'px' })
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        width: SVG_SIZE,
                        height: SVG_SIZE,
                        class: "absolute top-0 left-0 -rotate-90",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("circle", {
                          cx: SVG_SIZE / 2,
                          cy: SVG_SIZE / 2,
                          r: RADIUS,
                          stroke: _unref(NEUTRAL_RING_COLOR),
                          "stroke-width": STROKE_WIDTH,
                          fill: "none"
                        }, null, 8, _hoisted_25),
                        (getClampedScore(invite.doctor.npsScore) > 0)
                          ? (_openBlock(), _createElementBlock("circle", {
                              key: 0,
                              cx: SVG_SIZE / 2,
                              cy: SVG_SIZE / 2,
                              r: RADIUS,
                              stroke: getArcColor(invite.doctor.npsScore),
                              "stroke-width": STROKE_WIDTH,
                              fill: "none",
                              "stroke-dasharray": CIRCUMFERENCE,
                              "stroke-dashoffset": getArcOffset(invite.doctor.npsScore),
                              "stroke-linecap": "round"
                            }, null, 8, _hoisted_26))
                          : _createCommentVNode("", true)
                      ])),
                      _createElementVNode("div", {
                        class: "absolute rounded-full flex items-center justify-center text-sm font-semibold text-white",
                        style: _normalizeStyle({ ...INNER_STYLE, backgroundColor: getAvatarColor(invite.doctor.name) })
                      }, _toDisplayString(_unref(getDoctorInitials)(invite.doctor.name)), 5)
                    ], 4),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(getFirstAndSecondName)(invite.doctor.name)), 1),
                      _createElementVNode("span", _hoisted_29, "CRM " + _toDisplayString(invite.doctor.crm), 1),
                      (invite.acceptedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, " Aceitou em " + _toDisplayString(formatAcceptedAt(invite.acceptedAt)), 1))
                        : _createCommentVNode("", true),
                      (getExpirationLabel(invite))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(getExpirationLabel(invite)), 1))
                        : _createCommentVNode("", true),
                      (invite.declineReason)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, " Motivo: " + _toDisplayString(invite.declineReason), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-block px-2 py-[3px] rounded-[10px] text-[11px] font-medium whitespace-nowrap", getStatusBadgeClasses(invite)])
                      }, _toDisplayString(getStatusLabel(invite)), 3)
                    ])
                  ]),
                  (index < showcaseInvites.value.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                    : _createCommentVNode("", true),
                  (index < showcaseInvites.value.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                    : _createCommentVNode("", true),
                  (index < showcaseInvites.value.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(FilledButton, {
          text: "Fechar",
          width: "100%",
          height: "48px",
          class: "bg-primary30",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        })
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})